import styled from '@emotion/styled';

const LinkScrollItineraryStyle = styled('div')`
    .header {
        color: var(--sand-700);
        font-weight: 700;
    }
    .body {
        margin-top: 15px;
    }
    .link {
        color: var(--blue-400);
        font-weight: 700;
        text-decoration-line: underline;
        cursor: pointer;
        margin-bottom: 10px;
    }
`;

export default LinkScrollItineraryStyle;
